import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import Axios from 'axios';
import api from '../api';
import { wiewArquivoAnexo, downloadAnexo } from '@app/api/apiAnexo';

export interface sasFornecedorAvaliacaoCompliance {
  id: string;
  sasFornecedorId: string;
}

export interface sasFornecedorAvaliacaoComplianceFrom {
  id: string;
  sasFornecedorId: string;
  arquivo: any;
  dataValidade: Date;
  comentario: string;
}

export const getAllsasFornecedorAvaliacaoCompliance = () =>
  api.get<sasFornecedorAvaliacaoCompliance[]>('sasFornecedorAvaliacaoCompliance');

export const getAllsasFornecedorAvaliacaoComplianceByFornecedorId = (fornecedorId: string) =>
  api.get<sasFornecedorAvaliacaoCompliance[]>(
    `sasFornecedorAvaliacaoCompliance/getAllSasFornecedorAvaliacaoFinanceiraByFornecedorId/${fornecedorId}`,
  );

export const createsasFornecedorAvaliacaoCompliance = (
  fornecedorAvaliacaoComplianceFrom: sasFornecedorAvaliacaoComplianceFrom,
) => {
  const form = new FormData();
  form.append('arquivo', fornecedorAvaliacaoComplianceFrom['arquivo']);
  form.append('sasFornecedorId', fornecedorAvaliacaoComplianceFrom.sasFornecedorId);
  form.append('dataValidade', fornecedorAvaliacaoComplianceFrom.dataValidade);
  form.append('comentario', fornecedorAvaliacaoComplianceFrom.comentario);

  return api.post(`sasFornecedorAvaliacaoCompliance/createSasFornecedorAvaliacaoCompliance`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deletesasFornecedorAvaliacaoCompliance = (id: string) =>
  api.delete(`sasFornecedorAvaliacaoCompliance/${id}`);

export const viewArquivoAnexoFornecedorAvaliacaoCompliance = async (id: string, nomeDoArquivo: string) => {
  const url = '/api/sasFornecedorAvaliacaoCompliance/downloadAnexo';
  await wiewArquivoAnexo(id, nomeDoArquivo, url);
};

export const downloadArquivoAnexoFornecedorAvaliacaoCompliance = async (id: any, fileName: any) => {
  const url = '/api/sasFornecedorAvaliacaoCompliance/downloadAnexo';
  await downloadAnexo(id, fileName, url);
};
